<template>
    <div>
        <b-modal id="modal-prevent-closing" class="header-modal" no-close-on-backdrop hide-footer ref="modal-edit-duration">
            <div class="modal-edit-duration__body">
                <h4>
                    <strong>
                        Sửa thời gian hoàn thành
                    </strong>
                </h4>
                <div class="row">
                    <div class="col-md-4">
                        <label for="month">Tháng:</label>
                        <input @input="validateMonth" id="month" v-model="month" type="number" placeholder="Nhập tháng"
                                    autocomplete="off" class="form-control" min="1" max="12" />
                    </div>
                    <div class="col-md-4">
                        <label for="day">Ngày:</label>
                        <input v-model="day" @input="validateDay" id="day" type="number" placeholder="Nhập ngày"
                                    autocomplete="off"  class="form-control" />
                    </div>
                    <div class="col-md-4">
                        <label for="year">Năm:</label>
                        <input name="year" v-model="year" @input="validateYear" id="name" type="number" placeholder="Nhập tháng"
                                    autocomplete="off" class="form-control" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <label>Giờ:</label>
                        <input v-model="hour" @input="validateHour" id="hour" type="number" placeholder="Nhập giờ"
                                    autocomplete="off" class="form-control" />
                    </div>
                    <div class="col-md-4">
                        <label>Phút:</label>
                        <input v-model="minute" @input="validateMinute" id="minute" type="number" placeholder="Nhập phút" autocomplete="off" class="form-control" />
                    </div>
                </div>
                <div class="modal__actions text-right">
                    <a href="javascript:;" class="primary-color-txt font-size-17 btn-cancel" @click="handleHideModal">Hủy</a>
                    <a href="javascript:;" class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold line-height-1" @click="handleUpdate()">Đồng ý</a>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { SetDurationClassGroupAssign } from './../../../_api/LessonClassSchoolServices'
import moment from "moment";
export default {
    name: "ModalEditDuration",
    components:{
    },
    props: {
        type: {
            type: Number,
            default: 0
        },
        item:{
            type:Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default:{}
        }
    },
    data() {
        return {
            day:'',
            month:'',
            year:'',
            hour:'',
            minute:'',
            confirmActive: {},
            isLoading: false,
            date: new Date(2016, 9,  16)
        }
    },
    mounted(){
        let datetime = moment(this.item.duration)
        this.day = datetime.date();
        this.month = datetime.month() + 1;
        this.year  = datetime.year();

        this.hour  = datetime.hour();
        this.minute  = datetime.minute();

        console.log(this.item)
        this.handleShowModal()
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
    },
    methods: {
        moment,
        validateMonth(){
            let inputNum = parseInt(this.month);
            // Điều chỉnh giá trị đầu vào
            if (isNaN(inputNum) || inputNum <= 0) {
                this.month = 1;
            } else if (inputNum > 12) {
                this.month = 12;
            }
        },
        
        validateYear(){
            let inputNum = parseInt(this.year);
            // Điều chỉnh giá trị đầu vào
            if (isNaN(inputNum) || inputNum <= 2000) {
                this.year = 2000;
            } else if (inputNum > 4000) {
                this.year = 4000;
            }
        },

        validateHour(){
            let inputNum = parseInt(this.hour);
            // Điều chỉnh giá trị đầu vào
            if (isNaN(inputNum) || inputNum < 0) {
                this.hour = 0;
            } else if (inputNum > 24) {
                this.hour = 24;
            }
        },
        validateMinute(){
            let inputNum = parseInt(this.minute);
            // Điều chỉnh giá trị đầu vào
            if (isNaN(inputNum) || inputNum < 0) {
                this.minute = 0;
            } else if (inputNum > 59) {
                this.minute = 59;
            }
        },
        validateDay(){
            let inputNum = parseInt(this.day);
            
            // Điều chỉnh giá trị đầu vào
            if (isNaN(inputNum) || inputNum <= 0) {
                this.day = 1;
            } else if (inputNum > this.getMaxDaysInMonth()) {
                this.day = this.getMaxDaysInMonth();
            }
        },
        getMaxDaysInMonth() {
            // Tạo một đối tượng Date với ngày đầu tiên của tháng tiếp theo
            const date = new Date(this.year, Number(this.month), 0);
            // Lấy ngày cuối cùng của tháng hiện tại
            console.log(date,this.year, this.month)
            return date.getDate();
        },
        handleUpdate() {
            let self = this
            let inputMonth = Number(this.month)
            if(inputMonth<10){
                inputMonth = `0${this.month}`
            }

            let inputDay = Number(this.day)
            if(inputDay<10){
                inputDay = `0${this.day}`
            }


            let inputHour = Number(this.hour)
            if(inputHour<10){
                inputHour = `0${this.hour}`
            }

            let inputMinute = Number(this.minute)
            if(inputMinute<10){
                inputMinute = `0${this.minute}`
            }
            let duration = `${inputMonth}/${inputDay}/${this.year} ${inputHour}:${inputMinute}:00`
            const dateObj = new Date(duration);

            const isoDateTimeString = dateObj.toISOString();
            let params={
                id:this.item.id,
                classSchoolId:this.item.classSchoolId,
                groupId:this.item.groupId,
                duration:isoDateTimeString
            }
            SetDurationClassGroupAssign(params).then(res=>{
                if (res && res.data && !res.errors) {
                    self.$toast.success('Đã cập nhật lại thời gian hoàn thành')
                    this.handleHideModal()
                    self.$emit('handleDone')
                    
                }
            })
        },
        handleHideModal() {
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-edit-duration'].show()
        }
    }
}
</script>
<style lang="scss" scoped>
.modal-content {
    background-color: red;
}

.modal-edit-duration__body {
    padding: 20px;
    background-color: white;
    border-radius: 15px;
    .modal__actions{
        
        .btn-delete{
            color: white;
            padding: 5px 20px 5px 20px;
            border-radius: 15px;
            font-family: sans-serif;
        }
        .btn-cancel{
            margin-right: 10px;
            font-family: sans-serif;
        }
    }
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-between {
    justify-content: center
}
</style>